import React from 'react';

export default function withHooks(addHooksToProps) {
  return WrappedComponent => {
    const NewComponent = props => {
      const newProps = addHooksToProps(props);

      return <WrappedComponent {...newProps} />
    }

    NewComponent.displayName = `withHooks(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return NewComponent;
  }
};